import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { enableFullScreen, disableFullScreen } from '../actions/proctor';
import FullScreenProctor from '../components/Proctor/FullScreenProctor';

const mapStateToProps = state => {
  return {
    test: state.test,
    testSolutionSet: state.testSolutionSet,
    fullScreenEnabled: state.proctor.fullScreenEnabled,
    showBrowserTolerance: state.proctor.showBrowserTolerance,
    webcamPermission: state.proctor.webcamPermission,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      enableFullScreen,
      disableFullScreen,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(FullScreenProctor);
